import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const Strong = styled.strong`
  font-weight: ${themeGet('fontWeights.1')};
`

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.5')}px;
  text-decoration: none;

  > span {
    color: ${themeGet('colors.text.invertedBody')};

    &:hover {
      color: ${themeGet('colors.text.invertedMuted')};
    }
  }

  > svg {
    flex-shrink: 0;
    color: ${themeGet('colors.text.invertedMuted')};
    width: 16px;
    height: 16px;
  }
`
